import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 professional nursing clinical modules', '300 pages of organized visual reference content', '5 practical nursing bonuses', 'Advanced patient assessment and monitoring references', 'Injection, IV therapy, and vascular access guides', 'Wound care and infection prevention resources', 'Medication administration safety tools', 'Bedside procedures and equipment references', 'Emergency nursing and clinical deterioration guides', 'Professional documentation and workflow templates'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-121" data-mp="2fbemm9dmqr70">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-122" data-mp="2add71yfexa0a">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-123" data-mp="2acldsu9afod6">
          SPECIAL LAUNCH OFFER
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-tech bg-white shadow-lg" data-id="element-124" data-mp="uhqrueytaly8">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-125" data-mp="zgafqkwyu7t8">
            <h2 className="text-2xl leading-tight text-white sm:text-4xl" data-id="element-126" data-mp="13iypqvxf1krs">🩺 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-tech-light sm:text-base" data-id="element-127" data-mp="6uipa4srpqzw">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-128" data-mp="ftm8d8rxq6ee">
            <MockupImage data-id="element-129" data-mp="klxjl7s4lem9" />

            <div data-id="element-130" data-mp="kn8o59teaqef">
              <p className="font-heading text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-131" data-mp="3k8m06s101z1i">
                Complete 6-in-1 Professional Nursing Visual Reference System
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-132" data-mp="vfqxg36xhesq">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-133" data-mp="vde8h62r6466">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-134" data-mp="qg4h3kvszifp" />
                    <span className="text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-135" data-mp="1067ctsub7ahq">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-tech bg-tech-soft px-3 py-2 text-center" data-id="element-136" data-mp="7j3ci165vkca">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-137" data-mp="licg81d6klzd">
                  🔥 GET {PRODUCT} TODAY —{' '}
                  <span className="whitespace-nowrap font-heading text-3xl font-black text-tech sm:text-4xl" data-id="element-138" data-mp="1ww6t69gpbdav">
                    $27 USD
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-139" data-mp="20e49fn74k8mz">
                <CTAButton href={CHECKOUT_URL} data-id="element-140" data-mp="20h08jeupl3d0">🩺 GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-141" data-mp="25f1qfwgeewmw" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}